import React from "react";
import { Dropdown, Option, useId, makeStyles, OptionGroup } from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from 'prop-types';
import "./fluent-overide.scss";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 600,
    textAlign: "left",
    width: "100%",
    color: "#4E4E4E",

    "& button:disabled": {
      backgroundColor: "#f3f2f1",
      color: "#242424",
    }
  },
});

export const FluentDropdown = ({
  label,
  disabled,
  validationMessage,
  required,
  size,
  placeholder,
  defaultValue,
  options,
  onChange,
  componentStyle,
  selectedOptions,
  value,
  isControlled = false,
  labelStyle,
  clearable = false,
}) => {
  const dropdownId = useId("dropdown-default");
  const fieldStyle = useStyles();
  const combinedStyles = componentStyle || fieldStyle.root;
  if (isControlled) {
    return (
      <FluentField
        label={label}
        size={size}
        validationMessage={validationMessage}
        required={required}
        componentStyle={labelStyle}
      >
        <Dropdown
          aria-labelledby={dropdownId}
          placeholder={placeholder}
          onOptionSelect={onChange}
          value={value}
          disabled={disabled}
          className={combinedStyles}
          selectedOptions={selectedOptions}
          clearable={clearable}
          size={size}
        >
          {options?.map((option) => (
            <Option key={option} value={option} text={option}>
              {option}
            </Option>
          ))}
        </Dropdown>
      </FluentField>
    );
  }
  else {
    return (
      <FluentField
        label={label}
        size={size}
        validationMessage={validationMessage}
        required={required}
      >
        <Dropdown
          size={size}
          aria-labelledby={dropdownId}
          placeholder={placeholder}
          onOptionSelect={onChange}
          defaultValue={defaultValue}
          defaultSelectedOptions={[defaultValue]}
          disabled={disabled}
          className={combinedStyles}
          clearable={clearable}
        >
          {options?.map((option) => (
            <Option key={option} value={option} text={option}>
              {option}
            </Option>
          ))}
        </Dropdown>
      </FluentField>
    );
  }

};

export const GroupedFluentDropdown = ({
  label,
  disabled,
  validationMessage,
  required,
  size,
  placeholder,
  defaultValue,
  groupedOptions,
  onChange,
  componentStyle,
}) => {
  const dropdownId = useId("dropdown-default");
  const fieldStyle = useStyles();
  const combinedStyles = componentStyle || fieldStyle.root;
  return (
    <FluentField
      label={label}
      size={size}
      validationMessage={validationMessage}
      required={required}
    >
      <Dropdown
        aria-labelledby={dropdownId}
        placeholder={placeholder}
        onOptionSelect={onChange}
        defaultValue={defaultValue}
        defaultSelectedOptions={[defaultValue]}
        disabled={disabled}
        className={combinedStyles}
      >
        {groupedOptions?.map((gp) => (
          <OptionGroup label={gp?.label} key={gp?.label}>
            {gp?.options?.map((option) => (
              <Option key={option.Id} value={option.Id} text={option.Name}>
                {option.Name}
              </Option>
            ))}
          </OptionGroup>
        ))}       
      </Dropdown>
    </FluentField>
  );
};

FluentDropdown.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  componentStyle: PropTypes.string,
  size: PropTypes.string,
  selectedOptions: PropTypes.array,
  value: PropTypes.any,
  isControlled: PropTypes.bool,
  labelStyle: PropTypes.string,
  clearable: PropTypes.bool,
};